import React from 'react'
import Badge from 'App/components/Badge'
import PropTypes from 'prop-types'

export default class VerificationBadge extends React.Component {
  static propTypes = {
    country: PropTypes.object,
    verified: PropTypes.bool,
    width: PropTypes.number
  }
  render() {
    const {country, verified, width} = this.props
    if (!country) return <Badge color={'#D52C1F'} width={width}>No Verificada</Badge>
    if (verified) {
      return <Badge color={'#02bca0'} width={width}>Verificada</Badge>
    }
    return <Badge color={'#D52C1F'} width={width}>No verificada</Badge>
  }
}

